import React from 'react'
import { about, about1, about2, about3, product1, product2, product3, product4 } from '../../../assets/images';
import { useTranslation } from 'react-i18next';


const About = () => {

  const { t, i18n } = useTranslation();
  return (
      <div className="md:max-w-container max-w-containerSm mx-auto mt-[40px] md:mt-[88px]">
    <p className="text-[22px] md:text-[28px] font-semibold text-center mb-10">{t("Haqqımızda")}</p>
   <div className='md:flex'>
    <div>
   <img className='md:w-[467px] w-full' src={about}></img>
    </div>
    <div className='md:ml-[40px] md:w-[757px] mt-[18px] md:mt-0'>
       <div className='flex md:w-[340px] justify-between gap-[20px]'>
       <div> <img className='md:w-[132px]' src={about1}></img></div>
       <div> <img className='md:w-[132px]' src={about2}></img></div>
       <div> <img className='md:w-[132px]' src={about3}></img></div>
       </div>
       <div className='mt-[20px] md:mt-[185px]'>
        <p className='text-[18px] md:text-[24px] font-semibold'>{t("Dəriniz hər gün TANURA ile yenilənərək yenidən doğsun.")}</p>
        <p className='mt-[16px] md:mt-[28px] text-[16px]'>{t("2019-cu ildə sənayedə yerini alan dermokosmetik markamız TANURA elmi məlumatlara əsaslanan və biotexnoloji aktivlər, dərman bitkiləri ekstraktları, dərman bitkiləri yağları, vitaminlər ilə yaradılan formulaları ilə hər cür dəri problemlərinə hədəfə yönəlmiş həllər təklif edir, amin turşuları və güclü antioksidantlar, eyni zamanda sağlam dərinin formalaşmasını dəstəkləyir.")}</p>
       <a href='/about'> <button className='w-[132px] mt-[20px] md:mt-[32px] h-[40px] border-2 border-[#223077] rounded-xl hover:bg-[#023077] hover:text-[white] transition-transform duration-300 ease-in-out'>{t("Ətraflı bax")}</button></a>
       </div>
    </div>
   </div>
  </div>
  )
}

export default About